export const enum ProductMarketingType {
    FeatureProduct = 1,
    NewArrival = 2,
    SpecialOffer = 3
}

// export const DefaultDomain = 'http://vape.shreejisync.com';
export const DefaultDomain = 'https://e-shop.enoratech.com';


export enum ProductSearchType {
    Category = 'category',
    SubCategory = 'subcategory',
    Brand = 'brand'
}

export const enum AppToken {
    UserToken = 'token',
    UserDetail = 'userdetails',
    StoreDetail = 'store-detail'
}

export const CommonRegex = {
    PasswordPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/
};

export enum CommonErrorMessages {
    ServerError = 'Oops, something went wrong!',
    NoOrders = 'You have placed no orders.',
    EmailNotFound = 'We could not find an account for that e-mail address.',
    ResetPasswordError = 'Reset password link is expired or invalid.',
    NotFound = 'Oops! The content you are looking for cannot be found or not added'
}

export enum OderStatus {
    Order = 'Order',
    Inprocess = 'Inprocess',
    Shipped = 'Shipped',
    Completed = 'Completed',
    Cancel = 'Cancel',
    Return = 'Return',
    Closed = 'Closed'
}

export const OderStatusCSS: any = {
    Order: 'new',
    Inprocess: 'inprocess',
    Shipped: 'Shipped',
    Completed: 'completed',
    Cancel: 'cancled',
    Return: 'return',
    Closed: 'closed',
    Pending: 'new'
};

export const CustomerType: any = {
    Wholesaler: 'Wholesale',
    Customer: 'Customer'
};

export enum LoadingLabel {
    PleaseWait = 'Please wait...'
}

export enum MessageType {
    Success = 'success'
}

export enum PaymentStatus {
    Success = 'SUCCESS',
    Failed = 'FAILED',
    Pending = 'PENDING'
}

export const PaymentStatusText = {
    SUCCESS: 'Success',
    FAILED: 'Failed',
    PENDING: 'Pending'
};

export const StoreInfoType: any = {
    goodsservice: 'GOODS_SERVICE',
    return: 'RETURN_POLICY',
    refund: 'REFUND_POLICY',
    terms: 'TERM_OF_USE',
    privacy: 'PRIVACY'
};

export const StoreInfoTypeText: any = {
    goodsservice: 'Goods & Service',
    return: 'Return Policy',
    refund: 'Refund Policy',
    terms: 'Terms of Use',
    privacy: 'Privacy',
};

export enum HttpStatus {
    Unauthorized = 401
}
